var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkPinterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-2e6d8950-cc49-496b-af60-ae3483feee45",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.74 85.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.87,85.74c-4.42,0-8.68-.67-12.69-1.92,1.75-2.85,4.35-7.52,5.32-11.24,.52-2.01,2.66-10.2,2.66-10.2,1.4,2.66,5.48,4.93,9.82,4.93,12.93,0,22.25-11.89,22.25-26.67s-11.56-24.75-26.43-24.75c-18.5,0-28.33,12.41-28.33,25.94,0,6.29,3.35,14.12,8.69,16.61,.81,.38,1.24,.21,1.44-.57,.14-.59,.86-3.51,1.19-4.86,.1-.43,.05-.81-.29-1.23-1.75-2.16-3.16-6.1-3.16-9.78,0-9.46,7.16-18.6,19.36-18.6,10.53,0,17.91,7.17,17.91,17.44,0,11.6-5.86,19.64-13.48,19.64-4.2,0-7.36-3.48-6.34-7.74,1.21-5.1,3.54-10.6,3.54-14.28,0-3.28-1.76-6.03-5.43-6.03-4.3,0-7.76,4.44-7.76,10.41,0,3.8,1.28,6.36,1.28,6.36,0,0-4.23,17.94-5.01,21.3-.86,3.7-.52,8.92-.15,12.31C11.31,76.56,0,61.03,0,42.87,0,19.19,19.19,0,42.87,0s42.87,19.19,42.87,42.87-19.19,42.87-42.87,42.87Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkPinterest);
export default __webpack_public_path__ + "static/media/dark - pinterest.f20838b29bb10976dff27c6af5b1932d.svg";
export { ForwardRef as ReactComponent };